import angular from 'angular';
import { isEmpty } from 'lodash-es';

export default angular.module('app.filters.phone-number', []).filter(
  'phoneNumber',
  () =>
    /**
     * Format phone numbers to (999) 999-9999 or (999) 999-9999 x999
     * @param  {String} value The unformatted phone number
     * @return {String}       The formatted phone number
     */
    function(value) {
      // Assumes the the extension is the only A-Z character in the number
      let ext;
      if (value == null) {
        value = '';
      }
      let split = value.split(/[a-zA-Z]+/);

      // Strip all non-numeric values from the phone number
      let number = split[0].replace(/\D/g, '').trim();

      // Remove the . if it exists
      if (split[1] != null) {
        ext = split[1].replace(/^\./, '').trim();
      }

      // Handle country code
      if (number.length === 11) {
        number = number.substr(1);
      }

      // Format the phone number
      let ret = isEmpty(number)
        ? ''
        : `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(
            6,
            10
          )}`;

      // Apply the extension if it exists
      if (ext != null) {
        ret += ` x${ext}`;
      }

      // Return the number
      return ret.trim();
    }
);
